import React from 'react'
import FooterComponent from '../components/footer.component'
import GalleryComponent from '../components/gallery.component'
import GalleryImageComponent from '../components/galleryImage.component'
import useSEO from '../hooks/useSEO'

function Gallery() {
    useSEO({
        title: 'Gallery | Bridal, Arabic & Traditional Mehandi Designs – Mehandi Malabar',
        description: 'Browse our mehandi gallery showcasing bridal, Arabic, traditional and festival henna designs. Professional henna artistry in Malappuram, Kerala.',
        path: '/gallery',
    });

    return (
        <div>
            <GalleryComponent />
            <GalleryImageComponent />
            <FooterComponent />
        </div>
    )
}

export default Gallery
